import { render, staticRenderFns } from "./Circleprogressbar.vue?vue&type=template&id=80187460&"
import script from "./Circleprogressbar.vue?vue&type=script&lang=js&"
export * from "./Circleprogressbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports